__turbopack_context__.v({
  "amountInput": "XzmTWq_amountInput",
  "buttons": "XzmTWq_buttons",
  "catalogueCell": "XzmTWq_catalogueCell",
  "closeButton": "XzmTWq_closeButton",
  "content": "XzmTWq_content",
  "imageViewer": "XzmTWq_imageViewer",
  "name": "XzmTWq_name",
  "price": "XzmTWq_price",
  "wrapper": "XzmTWq_wrapper",
});
